import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getAccountSsoConnectionName} from 'src/openapi/admin/apis/AccountSingleSignOnApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    accountId: number,
};

export const useSsoName = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(getAccountSsoConnectionName(
        {accountId},
        {signal},
    )), [accountId, apiDispatch]);

    return useReadOnlyDataHook({
        initValue: {ssoConnectionName: ''},
        getDispatchAction,
    });
};
